import {
  UseMutateAsyncFunction,
  useMutation,
  useQuery,
  UseQueryResult,
} from '@tanstack/react-query';
import { http } from '../http';
import { CacheKeys } from './cache-configuration';
import { SessionGroup, SessionRequest } from '../../types/server-types';

export const useStartSession = (): UseMutateAsyncFunction => {
  const { mutateAsync } = useMutation<any, any, any>({
    mutationFn: http.startSession,
    onError: (error) => {
      throw error;
    },
  });
  return mutateAsync;
};

export const useStopSession = (): UseMutateAsyncFunction => {
  const { mutateAsync } = useMutation<any, any, any>({
    mutationFn: http.stopSession,
    onError: (error) => {
      throw error;
    },
  });
  return mutateAsync;
};

export const useSessionRequest = (
  requestId: number | undefined,
): UseQueryResult<SessionRequest> => {
  return useQuery({
    queryKey: [CacheKeys.SESSION_REQUEST, requestId],
    queryFn: () => http.getSessionRequest(requestId),
    enabled: !!requestId,
    refetchInterval: 1000,
  });
};

export const useActiveSessionGroup = (
  accountId: number | undefined,
): UseQueryResult<SessionGroup> => {
  return useQuery({
    queryKey: [CacheKeys.SESSION_GROUP, accountId],
    queryFn: () => http.getActiveSessionGroup(accountId),
    enabled: !!accountId,
  });
};
